export const ctmApp = require('./packages/ctm-vertical-home-contents')
